import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from "react";
import { DoubleArrowDownIcon } from "@/app/components/UI/Icons";
import cn from "@/app/utils/cn";
const ReadMore = t0 => {
  const $ = _c(20);
  const {
    text
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(true);
  const contentRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = contentRef.current;
      if (el) {
        setIsOverflowing(el.scrollHeight > el.clientHeight + 1);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = [text];
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = !isExpanded && "max-h-64 md:max-h-96";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("relative overflow-hidden", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = text ?? "";
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="custom-html" dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isExpanded || $[8] !== isOverflowing) {
    t7 = !isExpanded && isOverflowing && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white to-transparent md:h-32" />;
    $[7] = isExpanded;
    $[8] = isOverflowing;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
    t8 = <div ref={contentRef} className={t4}>{t6}{t7}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isExpanded || $[15] !== isOverflowing) {
    t9 = (isExpanded || isOverflowing) && <button type="button" onClick={() => setIsExpanded(_temp)} className="mx-auto mt-4 flex items-center justify-center gap-1 font-medium text-bluetiful-400"><span>{isExpanded ? "\u0628\u0633\u062A\u0646" : "\u0645\u0634\u0627\u0647\u062F\u0647 \u0628\u06CC\u0634\u062A\u0631"}</span><DoubleArrowDownIcon width={15} height={15} className={cn(isExpanded && "rotate-180")} /></button>;
    $[14] = isExpanded;
    $[15] = isOverflowing;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export default ReadMore;
function _temp(prev) {
  return !prev;
}